export const navs = [
	{ name: 'HOME', path: '/' },
	{ name: 'PORTFOLIO', path: '/portfolio' },
	{ name: 'CONTACT ME', path: '/contact-me' },
];

export const skills = [
	// Frontend Frameworks
	{ icon: <i className="fa-brands fa-react fa-4x"></i>, label: 'React' },
	{
		icon: (
			<img className="tech-img" src="/tech/nextjsimage.png" alt="Next.js" />
		),
		label: 'Next.js',
	},
	{ icon: <i className="fa-brands fa-js fa-4x"></i>, label: 'JavaScript' },
	{
		icon: (
			<img className="tech-img" src="/tech/typescript.svg" alt="TypeScript" />
		),
		label: 'TypeScript',
	},
	{ icon: <i className="fa-brands fa-sass fa-4x"></i>, label: 'SCSS' },
	{
		icon: (
			<img className="tech-img" src="/tech/tailwind.png" alt="Tailwind CSS" />
		),
		label: 'Tailwind CSS',
	},

	// Backend & APIs
	{
		icon: <img className="tech-img" src="/tech/nodeimage.png" alt="Node.js" />,
		label: 'Node.js',
	},
	{
		icon: (
			<img
				className="tech-img"
				src="/tech/node-js-express.png"
				alt="Express.js"
			/>
		),
		label: 'Express.js',
	},
	{
		icon: <img className="tech-img" src="/tech/ruby.jpg" alt="Ruby" />,
		label: 'Ruby',
	},
	{
		icon: <img className="tech-img" src="/tech/rails.png" alt="Rails" />,
		label: 'Rails',
	},
	{
		icon: (
			<img
				className="tech-img"
				src="/tech/postgresimage.png"
				alt="PostgreSQL"
			/>
		),
		label: 'PostgreSQL',
	},

	// Blockchain
	{
		icon: <img className="tech-img" src="/tech/solidity.svg" alt="Solidity" />,
		label: 'Solidity',
	},
	{
		icon: <img className="tech-img" src="/tech/ethersjs.png" alt="Ethers.js" />,
		label: 'Ethers.js',
	},
];

export const socialLinksData = (variant) => {
	return [
		{
			name: 'GitHub',
			url: 'https://github.com/julie-ify',
			icon:
				variant === 'dark'
					? '/images/icons/github-black.svg'
					: '/images/icons/github.svg',
		},
		{
			name: 'LinkedIn',
			url: 'https://www.linkedin.com/in/julianaifionu/',
			icon:
				variant === 'dark'
					? '/images/icons/linkedin-black.svg'
					: '/images/icons/linkedin.svg',
		},
		{
			name: 'Twitter',
			url: 'https://twitter.com/juliana_ifionu',
			icon:
				variant === 'dark'
					? '/images/icons/twitter-black.svg'
					: '/images/icons/twitter.svg',
		},
	];
};

export const validateEmail = (email) =>
	/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
